import React from 'react';
import { Button, FavoriteButton, Layout } from '@vwfs-bronson/bronson-react';
import { useDispatch, useSelector } from 'react-redux';
import {
  getFavouriteCompanyId,
  getSelectedOutlet,
  saveSelectedOutlet,
  setFavouriteCompanyId,
} from '../../services/redux/features/outlet.slice';
import { getOutletDisplayText } from './utils';

type Props = {
  company: DealerIntegration.Components.Schemas.MilesBrokerCompaniesData;
  searchText: string;
};

export const CompanyListItemForModal: React.FC<Props> = ({ company, searchText }) => {
  const itemText = getOutletDisplayText(company);
  const selectedOutlet = useSelector(getSelectedOutlet);
  const favouriteCompanyId = useSelector(getFavouriteCompanyId);
  const companyIsSelected = company.milesCompanyId === selectedOutlet?.milesCompanyId;
  const companyIsFavourite = favouriteCompanyId === company.milesCompanyId;
  const dispatch = useDispatch();

  const isMatchingSearch = !searchText || itemText.toLowerCase().includes(searchText.toLowerCase());

  return (
    <Layout middle center className="u-p-xsmall">
      <Layout.Item default="3/4">
        <Button
          className={
            (companyIsSelected ? 'u-text-pale u-bg-brand' : 'u-bg-white') + (isMatchingSearch ? '' : ' u-text-pale')
          }
          simple
          small
          full
          disabled={companyIsSelected || !isMatchingSearch}
          onClick={(e) => {
            e.preventDefault();
            dispatch(saveSelectedOutlet(company));
          }}
        >
          {itemText}
        </Button>
      </Layout.Item>

      <Layout.Item default="1/4">
        <Layout center>
          {isMatchingSearch && (
            <FavoriteButton
              active={companyIsFavourite}
              iconOnly
              onPressedChange={() => {
                if (companyIsFavourite) {
                  dispatch(setFavouriteCompanyId(undefined));
                } else {
                  dispatch(setFavouriteCompanyId(company.milesCompanyId));
                }
              }}
            />
          )}
        </Layout>
      </Layout.Item>
    </Layout>
  );
};
